module.exports = __webpack_public_path__ + "img/words02.dcd2e955.png";